import React, {useState} from "react"
import {graphql} from "gatsby"
import ReactMarkdown from "react-markdown"
import Layout from "../components/App/Layout"
import Navbar from "../components/App/Navbar"
import PageBanner from '../components/Common/PageBanner'
import Footer from "../components/App/Footer"
import WebDataRocksReport from "../components/WebDataRocksReports/WebDataRocksReport";
import Reports from "../components/Report/Reports"
import { withAuthenticationRequired } from '@auth0/auth0-react';
import Carousel from "../components/Carousel/Carousel";

const openTabSection = (evt, tabNmae) => {
    let i, tabcontent, tablinks;
    tabcontent = document.getElementsByClassName("tabs_item");
    for (i = 0; i < tabcontent.length; i++) {
        tabcontent[i].classList.remove("fadeInUp");
        tabcontent[i].style.display = "none";
    }

    tablinks = document.getElementsByTagName("li");
    for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace("current", "");
    }
    document.getElementById('tab'+tabNmae.idx).style.display = "block";
    document.getElementById('tab'+tabNmae.idx).className += " fadeInUp animated";
    evt.currentTarget.className += "current";
}

const openNewTab = () => {
    const anchors = document.querySelectorAll('a');
    anchors.forEach((a) => {
        a.setAttribute('target', '__blank');
        a.setAttribute('rel', 'noopener noreferrer');
    });
}

const NewsletterTemplate = ({ data }) => {
    const [rpt, setRpt] =  useState("basicReport");
    const reportsComponents = [
        {key: 'basicReport', label: 'Gráficos', icon: 'flaticon-analytics'},
        {key: 'advanceReport', label: 'Consulta avanzada', icon: 'flaticon-segmentation'},
    ]
    function onRptSelected(rpt, e){
        setRpt(rpt);
        e.preventDefault();
    }

    React.useEffect(() => {
        // Runs after the first render() lifecycle
        openNewTab();
    }, []);


    const newsletter = data.strapiNewsletters;
     const reportsData = newsletter.AdvancedChart;
    const chartsBasicData = newsletter.BasicChart; // owlmx:20210214
    const carousel = newsletter.carousel_newsletter;
    return (
        <Layout>
            <Navbar />
            <PageBanner
                pageTitle="Newsletter"
                homePageText="Newsletters"
                homePageUrl="/newsletters"
                activePageText={newsletter.title}
            />
            <section className="courses-details-area pb-100">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 col-md-12">
                            <div className="courses-overview">
                                <h1>{newsletter.title}</h1>
                                <p>{newsletter.description}</p>
                                <div className="courses-details-desc">
                                    <ul className="nav nav-tabs" id="myTab" role="tablist">
                                        <li
                                            className="current"
                                            onClick={(e) => openTabSection(e, {idx: '_0'})}
                                        >
                                            {newsletter.chart_title}
                                        </li>
                                        {
                                            newsletter.sections.map((section, idx) => {
                                                return (
                                                    <li
                                                        onClick={(e) => openTabSection(e, {idx})}
                                                        key={idx}
                                                    >
                                                        {section.title}
                                                    </li>
                                                )
                                            })
                                        }
                                    </ul>
                                    <div className="tab-content">
                                        <div id="tab_0" className="tab-pane tabs_item">
                                            {/* Report options buttons */}
                                            <div className="row">
                                                {reportsComponents.map((item) => {
                                                    return (
                                                        <div className="col-lg-6 col-sm-6 col-md-6">
                                                            <a href="#!" onClick={(e) => onRptSelected(item.key, e) }>
                                                                <div className={`single-industries-serve-box small ${item.key==rpt ? "selected" : ""}`}>
                                                                    <div className="icon"><i className={`${item.icon}`}></i></div>
                                                                    {item.label}
                                                                </div>
                                                            </a>
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                            <hr/><br/>
                                            {/* Displaying the report data */}
                                            <div className="row">
                                                <div className="col-lg-12 col-md-12">
                                                    {rpt == 'basicReport' && <Reports reportsConfig={chartsBasicData}/>}
                                                    {rpt == 'advanceReport' && <WebDataRocksReport reportsData={reportsData} />}
                                                </div>
                                            </div>
                                        </div>
                                        {
                                            newsletter.sections.map((section, idd) => {
                                                return (
                                                    <div key={idd} id={'tab'+idd} className="tab-pane tabs_item">
                                                        <div className="courses-overview">
                                                            <ReactMarkdown source={section.content} />
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <Carousel carousel={carousel}></Carousel>
                    </div>
                </div>
            </section>
            <Footer />
        </Layout>
    )
}

export const query = graphql`
  query GetBlog($id: String) {
      strapiNewsletters(id: { eq: $id })  {
          id
          title
          description
          sections {
            title
            content
          }
          chart_title
        BasicChart {
            title            
            caption
            basic_chart {
                config
            }
        }
        AdvancedChart {
          title
          caption
          advanced_chart {
            dataFrequency
            config {
              graph {
                title
                reportTitle
                chartId
                chartType
                xAxisLabel
                yAxisLabel
              }
              dataSource {
                dataSourceType
                filename
              }
              slice {
                rows {
                  uniqueName,
                  filter {
                    members
                  }
                }
                columns {
                  uniqueName
                }
                measures {
                  uniqueName
                  format
                }
              }
              options {
                grid {
                  type
                  showTotals
                  showGrandTotals
                }
              }
            formats {
                name
                thousandsSeparator
                decimalSeparator
                decimalPlaces
                currencySymbol
                currencySymbolAlign
                nullValue
                textAlign
                isPercent
            }
              localization
            }
          }
        }
    carousel_newsletter {
      carousel {
        title
        url
        image {
          url
        }
      }
    }
    }
}
`

export default withAuthenticationRequired(NewsletterTemplate)
